"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pagination = exports.table = void 0;

var _base = require("./base");

var _swatches = require("../swatches");

var table = {
  rowBg: _swatches.monochrome.white,
  rowHoverBg: _base.secondary.brand,
  rowHoverBorder: _base.primary.brand,
  evenRowBg: _swatches.monochrome.superLight,
  headText: _swatches.monochrome.mediumDark,
  headBg: _swatches.monochrome.light,
  cellText: _swatches.monochrome.dark,
  footerBorder: _swatches.monochrome.medium,
  activeSortIcon: _base.primary.brand
};
exports.table = table;
var pagination = {
  pagerBg: _swatches.monochrome.white,
  pagerText: _swatches.monochrome.dark,
  pagerHoverText: _base.primary.brand,
  pagerActiveText: _swatches.monochrome.white,
  pagerActiveBg: _base.primary.brand,
  pagerDisabledBg: _swatches.monochrome.superLight,
  pagerBorder: _swatches.monochrome.medium,
  directionIcon: _swatches.monochrome.mediumDark
};
exports.pagination = pagination;
//# sourceMappingURL=table.js.map